import CustomerDashboardController from "emun.customer/customer-dashboard.controller";
import AutoQuery from "servicestack/auto-query/auto-query.es6";
export default class CustomerDashboardToolbarController extends CustomerDashboardController {
  constructor(retailerPrompt) {
    super(retailerPrompt);
    const $ctrl = this;
    // console.warn($ctrl);
    $ctrl.quickReportsQuery = new AutoQuery({
      url: "QueryQuickReports.json?",
      orderBy: "Type,Name",
      sortOptions: {
        "Type,Name": "Name: A to Z",
        "-Type,Name": "Name: Z to A",
      },
      tagCriteria: {
        Dashboards: "Customer",
      },
      autoLoad: true,
      onLoaded(args) {
        $ctrl.quickReports = args.results;
      },
      pageSize: 1000,
    });
  }

  $onInit() {
    const $ctrl = this;
    super.$onInit();
    // console.info("BL*** in dashboard-toolbar controller oninit");
    if (
      $ctrl.customerConfig.addressVerification &&
      $ctrl.customer &&
      $ctrl.customer.tags["latitude"] === undefined
    ) {
      $ctrl.validateAddress($ctrl.customer);
    }
  }

  exportQuickReport(report) {
    const $ctrl = this;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "RunReport?reportName=QuickReport&displayName=" +
        report.name +
        " &output=xlsx&QuickReportID=" +
        report.id +
        "&@CustomerID=" +
        $ctrl.customer.id +
        "&QuickReportName=" +
        report.name
    );

    return (location.href = url);
  }
}
